<div class="relative w-full">
  <label class="block text-sm font-medium text-gray-700 mb-1">
    {{ placeholder() }}
  </label>

  <div
    class="z-20 w-full bg-white border rounded shadow-lg overflow-auto overflow-x-hidden scroll-smooth"
    style="max-height: 200px">
    <input
      type="text"
      [(ngModel)]="searchTermModel"
      [placeholder]="'Search ' + placeholder()"
      class="px-3 py-2 border-b focus:outline-none" style="width: 100%;" />

      @for (option of filteredOptions(); track option) {
        <div>
          <div
            (click)="toggleSelection(option)"
            class="cursor-pointer px-4 py-2 flex items-center w-full">
            <input
              type="checkbox"
              [checked]="isSelected(option)"
              class="mr-2"
              readonly />
              <span class="truncate">{{ option[computedConfig().labelKey] }}</span>
            </div>
          </div>
        }
      </div>
    </div>
